import { SNIPPET_DETECTION, VENDORED_DEPENDENCY_DETECTION } from '../../../shared/featureFlags/flagNames';

import { isFeatureEnabled, useIsFeatureEnabled } from './featureFlags';

/**
 * Frontend helper to check whether the Quick Import scan-methods UI should be shown.
 * Returns true if either VENDORED_DEPENDENCY_DETECTION or SNIPPET_DETECTION is enabled.
 */
export const shouldShowQuickImportScanMethods = (): boolean =>
  isFeatureEnabled(VENDORED_DEPENDENCY_DETECTION) ||
  isFeatureEnabled(SNIPPET_DETECTION);

/**
 * Hook to check if the scan methods section should be visible.
 * Returns true if either VENDORED_DEPENDENCY_DETECTION or SNIPPET_DETECTION is enabled.
 */
export const useShouldShowQuickImportScanMethods = (): boolean => {
  const hasVendored = useIsFeatureEnabled(VENDORED_DEPENDENCY_DETECTION);
  const hasSnippets = useIsFeatureEnabled(SNIPPET_DETECTION);
  return hasVendored || hasSnippets;
};
